import axios from "axios";
import cards from "../../models/gestionTiempos/cards";
import cardAssign from "../../models/gestionTiempos/assignCard";
import bookingError from "../../models/gestionTiempos/bookingErros";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getCards() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let empId = localStorage.getItem("empId");
    return axios.get(`${url}/emptarj/${empId}`, { headers }).then(({ data }) =>
      data.map((item) => {
        return cards.fromJson(item);
      })
    );
  }
  getCardsAsign() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/emptarj/tarjetas`, { headers }).then(({ data }) =>
      data.map((item) => {
        return cardAssign.fromJson(item);
      })
    );
  }

  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;
    if (data.to) {
      payload = {
        empId: empId,
        tarjId: data.cardId,
        fecDesde: data.from + "T00:00:00.000Z",
        fecHasta: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
        operId: operId,
      };
    } else {
      payload = {
        empId: empId,
        tarjId: data.cardId,
        fecDesde: data.from + "T00:00:00.000Z",
        operId: operId,
      };
    }

    return axios.post(`${url}/emptarj`, payload, { headers });
  };
  delete = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let empId = localStorage.getItem("empId");
    let fecDesde = data.fecDesde;
    let tarjId = data.tarjId;

    return axios.delete(`${url}/emptarj/${empId}&${tarjId}&${fecDesde}`, {
      headers,
    });
  };
  edit = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = localStorage.getItem("empId");
    let fecDesde = data.originFrom;
    let tarjId = data.cardId;
    let payload = {};

    if (data.from !== data.originFrom) {
      payload.de = data.from + "T00:00:00.000Z";
    }

    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        ha: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      };
    }

    return axios
      .patch(`${url}/emptarj/${empId}&${tarjId}&${fecDesde}`, payload, {
        headers,
      })
      .then(() => {});
  };
  getBookingErros(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let tarjeta = data;

    return axios
      .get(`${url}/regis/errFichadas/${tarjeta}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return bookingError.fromJson(item);
        })
      );
  }
  repairError = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/regis/repairErrFichadas`, data, { headers });
  };
}
export default service;
